import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ITagModel } from 'dist/lib-core-shared/lib/models/product/dto/tags/product-tags.model';

@Component({
  selector: 'app-product-tag',
  templateUrl: './product-tag.component.html',
  styleUrls: ['./product-tag.component.scss']
})
export class ProductTagComponent implements OnInit {
  @Input() tagInfo!: ITagModel;
  @Input() searchQuery?: string;
  selected: boolean = false;
  @Output() tagSelected = new EventEmitter<any>();
  @Input() unsaved?: boolean;
  @Input() newTag?: boolean;
  @Output() tagToBeRemoved = new EventEmitter<number>();
  @Output() tagToBeDeleted = new EventEmitter<any>();
  @ViewChild('tagName') tagName!: ElementRef;
  @Input() usedInTagsAdmin?: boolean;
  
  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.searchQuery) {
      const searchQuery = this.searchQuery;
      let result = this.tagName.nativeElement.innerHTML;

      if (searchQuery && result) {
        this.tagName.nativeElement.innerHTML = result.replace(new RegExp(searchQuery, "gi"), (query: string) => `<span class="highlight">${query}</span>`);
      }
    }
  }

  selectTag() {
    if (!this.usedInTagsAdmin) {
      this.selected = !this.selected;
    }

    let selectedTagDto = {
      isTagSelected: this.usedInTagsAdmin ? undefined : this.selected,
      tag: this.tagInfo
    }

    this.tagSelected.emit(selectedTagDto);
  }

  removeTag() {
    this.tagToBeRemoved.emit(this.tagInfo.id);
  }

  deleteTag(event: any) {
    event.stopPropagation();
    this.tagToBeDeleted.emit(this.tagInfo);
  }
}
